import React from 'react';

import { ScreenWithOptionalParams, TabNavigationContextProvider, useStackNavigationContext } from 'core/navigation';
import { AnalyticsContextProvider } from '../../analytics';
import { CaseScreenContainer } from '../../component';
import { CaseNavigator, CASE1_ROUTE, ROOT_ROUTE } from '../../navigation';

interface ScreenState
  extends Readonly<{
    tabs: string[];
    screens: ScreenWithOptionalParams[];
  }> {}

const createInitialState = (): ScreenState => {
  const initialState: ScreenState = {
    tabs: ['Overview', 'Challenges', 'Benefits'],
    screens: [{ screen: CASE1_ROUTE.OVERVIEW }, { screen: CASE1_ROUTE.CHALLENGES }, { screen: CASE1_ROUTE.BENEFITS }],
  };

  return initialState;
};

const INITIAL_SELECTED_TAB_INDEX = 0;

export const Case1Screen = React.memo(() => {
  const { push } = useStackNavigationContext();

  const [state] = React.useState<ScreenState>(() => createInitialState());

  const OnNextCaseButtonPressCallback = React.useCallback(() => push({ screen: ROOT_ROUTE.CASE2 }), [push]);

  return (
    <TabNavigationContextProvider screens={state.screens} initialSelectedScreenIndex={INITIAL_SELECTED_TAB_INDEX}>
      <AnalyticsContextProvider>
        <CaseScreenContainer tabs={state.tabs} onNextCaseButtonPress={OnNextCaseButtonPressCallback}>
          <CaseNavigator />
        </CaseScreenContainer>
      </AnalyticsContextProvider>
    </TabNavigationContextProvider>
  );
});
